//export const BACKEND_URL = "http://localhost:8080";
export const BACKEND_URL = "https://api.bookmarked.andreeagugiuman.com";
